import { MeasureBadges } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/ActionableTrainGridItem/MeasureBadges";
import {
  AltTransMeasure,
  AltTransTrainEvent,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { TrainEventTypeEnum } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/types/trainEventTypeEnum";
import { FC } from "react";
import { Badge } from "shared/components/Spor";

type MeasureDescriptionProps = {
  hasPassed: boolean;
  measures: AltTransMeasure[];
  events: AltTransTrainEvent[];
};

const EVENT_TYPES_REQUIRING_MEASURE = [
  TrainEventTypeEnum.TRAIN_CANCELLED,
  TrainEventTypeEnum.TRAIN_CHANGED_ROUTE,
];

export function trainRequiresMeasure(events: AltTransTrainEvent[]): boolean {
  return events.some(({ type }) =>
    EVENT_TYPES_REQUIRING_MEASURE.includes(type),
  );
}

export const MeasureDescription: FC<MeasureDescriptionProps> = ({
  hasPassed,
  measures,
  events,
}) => {
  if (hasPassed) {
    return <Badge colorPalette="neutral">Passert</Badge>;
  }

  if (measures.length === 0) {
    if (trainRequiresMeasure(events)) {
      return <Badge colorPalette="red">Trenger tiltak</Badge>;
    }

    return <Badge colorPalette="yellow">Ubehandlet</Badge>;
  }

  return <MeasureBadges measures={measures} />;
};
